jQuery(document).ready(function ($) {

    $('.file-upload input').change(function () {
        $('.file-upload .gfield_label').text(this.files[0].name);
    });

    if ($('.page-template-page-form').length) {
        $('.ginput_container_checkbox input').on('change', function () {
            $('.ginput_container input').prop('disabled', false);
            $('.ginput_container select').prop('disabled', false);
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Add an event listener to each Gravity Form
    document.querySelectorAll('.gform_wrapper form').forEach(function (form) {
        form.querySelector('input[id*="gform_submit_button"]').addEventListener('click', function () {
            // Add the loading class when the form is submitted
            form.classList.add('form-loading');
        });
    });
});
